import React, { useState, useEffect, useRef } from "react";
import { Formik, useFormik } from "formik";

import * as Yup from "yup";
import ImageEditor from './Editor/ImageEditor';
import ReactTags from 'react-tag-autocomplete'

import 'react-tagsinput/react-tagsinput.css'

import GalleryModal from "./Gallery/GalleryModal";

import { stripHtml } from "./Forms/sharedUtils";

const blogScheme = Yup.object().shape({
  title: Yup.string().required("Required"),
  image_url: Yup.string().required("Required"),
  content: Yup.string().required("Required"),
  author_name: Yup.string(),
});

const BlogAdd = (props) => {
  const { blog } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [openingModal, setOpeningModal] = useState(false);
  const formRef = useRef();

  console.log("BlogAdd", props);
  const handleSave = (data) => {
    console.log("savesave", data);
    const tag_list = (data.tag_list || []).map(({name})=>(name)).join(',');    

    setIsLoading(true);
    fetch("/admin/blogs.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: JSON.stringify({ blog: {...data, tag_list} }),
    })
      .then((resp) => {
        return resp.json();
      })
      .then((resp) => {
        console.log("resp", resp);
        setIsLoading(false);
        window.location.href = `/admin/blogs/${resp.resource.slug}/edit`;
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      ...(blog || {}),
    },
    validationSchema: blogScheme, // replace with your actual validation schema
    onSubmit: handleSave, // replace with your form submission function
  });

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = formik;
  const handleSelect = (images) => {
    setOpeningModal(null);
    setFieldValue("image_url", images ? images[0].image_url : null);
  };
  console.log('errors', errors);
  const onDeleteTag = (idx) => {
    const tags = (values.tag_list || []).slice(0);
    tags.splice(idx, 1)
    setFieldValue('tag_list', tags);
  }
  const onAddTag = (tag) => {
    console.log('ddd', tag);
    const tags = [...(values.tag_list || []), {name: tag.name, id: tag.name}]
    setFieldValue('tag_list', tags);
  }  
  const suggestions = [
    { id: "Bananas", name: "Bananas" },
    { id: "Mangos", name: "Mangos" },
    { id: "Lemons", name: "Lemons" },
    { id: "Apricots", name: "Apricots" }
  ]
  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} ref={formRef}>
          <div className="row with-forms">

            <div className="col-md-6">
              <h5>
                Listing Title
                <sup className="required">*</sup>
              </h5>
              <input
                type="text"
                name="title"
                id="title"
                placeholder="Blog Title"
                autoComplete="off"
                value={`${values.title || ""}`}
                onChange={handleChange}
                onBlur={handleBlur}
                required={true}
                className={
                  errors.title && touched.title
                    ? "search-field error"
                    : "search-field"
                }
              />
            </div>
          </div>

          <div className="row with-forms">
            <div className="col-md-12">
              <h5>
                Content
                <sup className="required">*</sup>
              </h5>
                <textarea
                required={true}
                className="invisibled"
                name="content"
                value={`${stripHtml(values.content) || ""}`}
                onChange={(e) => e}
              ></textarea>
              <ImageEditor
                  className={stripHtml(values.content) ? '' : 'error'}
                  value={`${values.content || ""}`}
                  onChange={(value) => setFieldValue("content", value)}
              />

            </div>
          </div>
        
        <div className="row with-forms">
          <div className="col-md-12">
            <h5>
              Featured Image
              <sup className="required">*</sup>
            </h5>
          </div>
          <div className="col-md-2">
            <button
              className="button gray"
              onClick={(e) => setOpeningModal("image")}
            >
              {values.image_url ? 'Change' : 'Add'} media
            </button>
          </div>
          <div className="col-md-10">
            {values.image_url && (
              <div>
                <img src={values.image_url}/>
              </div>
            )}
          </div>
        </div>
        <div className="row with-forms">
            <div className="col-md-12">
              <h5>
                Tags
                <sup className="required">*</sup>
              </h5>
              <ReactTags
                tags={values.tag_list || []}
                suggestions={suggestions}
                onDelete={onDeleteTag}
                onAddition={onAddTag} 
                allowNew={true}
            />
            </div>
          </div>        
       
        <div className={`form-action`}>
          <button
            type="submit"
            className="button preview"
            disabled={isLoading}
          >
            Save &amp; Edit
          </button>
        </div>
      </form>

      <GalleryModal
        maxNumberOfFiles={1}
        isOpen={!!openingModal}
        onCancel={(e) => setOpeningModal(null)}
        onSelectPhoto={handleSelect}
      />
    </React.Fragment>
  );
};

export default BlogAdd;
